import React from "react";

const UserContext = React.createContext({
	usuario: null,
	setUsuario: null,
	estadoBackend: false,
	UsuarioLogueadoHandler: () => {},
	UsuarioDeslogueadoHandler: () => {},
	suppressErrors: false,
	setSuppressErrors: () => {}
});

export default UserContext;
